if (!customElements.get('fp-customer-proof')) {
  customElements.define('fp-customer-proof', class extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('[data-fp-proof-guide]');
      if (!button || button.dataset.bound) return;
      const findGuide = () => document.querySelector('product-info size-chart-dialog');
      if (!findGuide()) return;
      customElements.whenDefined('size-chart-dialog').then(() => {
        if (!this.isConnected || !findGuide()) return;
        button.hidden = false;
        button.dataset.bound = 'true';
        button.addEventListener('click', () => {
          const guide = findGuide();
          if (typeof guide?.open === 'function') guide.open();
        });
      });
    }
  });
}
